<script setup lang="ts">
withDefaults(
  defineProps<{
    value?: number
    caption: string
    label: string
  }>(),
  {
    value: 0,
  },
)
</script>

<template>
  <svg viewBox="0 0 220 132" class="h-32 w-full" role="img" :aria-label="label">
    <defs>
      <linearGradient id="finest-gauge" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#1566e9" />
        <stop offset="55%" stop-color="#0da9a1" />
        <stop offset="100%" stop-color="#08d570" />
      </linearGradient>
    </defs>
    <path
      d="M20,110 A90,90 0 0 1 200,110"
      fill="none"
      class="stroke-surface-3"
      stroke-width="16"
      stroke-linecap="round" />
    <path
      d="M20,110 A90,90 0 0 1 200,110"
      fill="none"
      stroke="url(#finest-gauge)"
      stroke-width="16"
      stroke-linecap="round"
      pathLength="100"
      :stroke-dasharray="`${value} 100`" />
    <text x="110" y="96" text-anchor="middle" class="fill-ink text-[38px] font-semibold">{{ value }}%</text>
    <text x="110" y="120" text-anchor="middle" class="fill-ink-3 text-[12px]">{{ caption }}</text>
  </svg>
</template>
